import React, { useState, useEffect } from 'react';
import Breadcrumb from "components/shared/Breadcrumb";
import Select from 'react-select';
import MaterialTable from 'material-table';
import { toast } from "react-toastify";
import hisService from "services/admin/masters/hisService";
import ConfirmBox from "components/shared/VmwareMappingConfirmBox";
import {
  MSG_CREATE_RECORD,
  MSG_DELETE_RECORD,
  MSG_MAPPING_DELETE_WARNING
} from "constants/admin/masters/vmware";
import {
  ERROR_MESSAGE_UNKNOWN
} from "constants/common";
import { getMatrixId } from "utils/matriceHelpers";
function ManageHisCombineKey({ props }) {
  const [breadcrumbs, setBreadCrumbs]
    = useState([
      { title: "HIS Masters Mapping", url: "/admin/master/his/" },
      { title: "Manage Mapping" },
    ]);
  const serviceObj = new hisService();

  const [combineKeyDetails, getCombinekeyDetails] = useState([]);
  const [serverModelList, setServerModelList] = useState(null);
  const [hisReleaseVersionList, setHisReleaseVersionList] = useState(null);
  const [selectedServerModel, setServerModel] = useState(null);
  const [hisOsList, setHisOsList] = useState(null);
  const [selectedHisOs, setHisOs] = useState(null);
  const [selectedHisReleaseVersion, setHisReleaseVersion] = useState(null);
  const [combineKey, setCombineKey] = useState("");
  const [release, setRelease] = useState("");
  const [combineKeyError, setCombineKeyError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [showDeleteConfirmBox, setDeleteConfirmBoxFunction] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [itemToBeDeleted, setItemToBeDeleted] = useState(null);
  const [copiedCombineKey, setCopiedCombineKey] = useState(0);

  const Id = getMatrixId(window.location.pathname);

  useEffect(() => {
    getData();
  }, [])

  const getData = () => {
    serviceObj.getAllInitialData(Id)
      .then((response) => {
        getCombinekeyDetails(response?.his_combine_keys_list);
        // structuring server model items for dropdown list
        let serverModelList = response?.server_model_dropdown_list.map((item) => {
          return { id: item.id, value: item.name, label: item.name, disabled: item.disabled }
        })
        setServerModelList(serverModelList);
        // structuring Os items for dropdown list
        let HisOsList = response?.os_dropdown_list.map((item) => {
          return { id: item.id, value: item.name, label: item.name, disabled: item.disabled }
        })

        setHisOsList(HisOsList)
        // structuring server model items for dropdown list
        let HisReleaseVersionList = response?.his_release_version_dropdown_list.map((item) => {
          return { id: item.id, value: item.name, label: item.name, disabled: item.disabled }
        })

        setHisReleaseVersionList(HisReleaseVersionList)
      })
      .catch((error) => {
        toast.error(ERROR_MESSAGE_UNKNOWN);
      })
  }
  const submitForm = async (e) => {
    e.preventDefault();
  }
  const resetForm = () => {
    setServerModel(null);
    setHisReleaseVersion(null);
    setCombineKey("");
    setCombineKeyError(false);
    setErrorMsg("");
    setCopiedCombineKey(null);
    setHisOs(null)
    setRelease("")
  }

  const getCombineKeyValue = () => {

    if (selectedServerModel && selectedHisReleaseVersion && selectedHisOs && release) {
      setCombineKey(selectedServerModel?.value + "-" + selectedHisReleaseVersion?.value + "-" + selectedHisOs?.value + "-" + release)

    } else if (!selectedServerModel || !selectedHisReleaseVersion || !selectedHisOs || !release) {
      // toast("Please select values from all dropdown to generate combine key!")
      setCombineKeyError(true);
      setErrorMsg("Please select values from all above dropdowns to generate combine key!")
    }
  }
  const changeCombineKey = (e) => {
    setCombineKey(e.target.value);
  }
  const changeRelease = (e) => {
    setRelease(e.target.value)
  }


  const setServerModelFunction = (e) => {
    setServerModel(e);
    setCombineKey("")
  }
  const setHisReleaseVersionFunction = (e) => {
    setHisReleaseVersion(e);
    setCombineKey("");
  }

  const setHisOsFunction = (e) => {
    setHisOs(e);
    setCombineKey("");
  }
  const addCombineKey = () => {
    // check validation
    if (combineKey !== "") {
      // call api
      let apiData = {
        combine_key: combineKey,
        server_model_id: selectedServerModel.id,
        his_release_version_id: selectedHisReleaseVersion.id,
        operating_system_id: selectedHisOs.id,
        release: release,
        copy_from_id: copiedCombineKey ? copiedCombineKey.id : 0
      }
      serviceObj.createCombinekey(apiData).then((response) => {
        toast.success(MSG_CREATE_RECORD);
        getData();
        resetForm();
      })


    }
    else {
      setCombineKeyError(true);
      setErrorMsg("Please select values from all above dropdowns to generate combine key!")
    }

  }
  const deleteCombinekey = () => {

    serviceObj.deleteHisCombineKey(itemToBeDeleted.id)
      .then((response) => {
        toast.success(MSG_DELETE_RECORD);
        setDeleteConfirmBoxFunction(false)
        setConfirmMessage("");
        getData();
        setItemToBeDeleted(null);
      })
      .catch((error) => {
        setDeleteConfirmBoxFunction(false)
        setConfirmMessage("");
        setItemToBeDeleted(null);
      })
  }
  const showDeleteWarning = (rowData) => {
    setDeleteConfirmBoxFunction(true);
    setItemToBeDeleted(rowData);
    setConfirmMessage(MSG_MAPPING_DELETE_WARNING + rowData.combine_key + "?")
  }
  const cancelDeleteItem = () => {
    setDeleteConfirmBoxFunction(false);
    setItemToBeDeleted(null);
  }
  return (
    <div className="form-wrap mt-3">
      <Breadcrumb data={breadcrumbs} disableEditTitle={true} />
      {showDeleteConfirmBox ? (
        <ConfirmBox
          actionHandler={deleteCombinekey}
          handleSubmit={deleteCombinekey}
          cancelDeleteItem={cancelDeleteItem}
        >
          {confirmMessage}
        </ConfirmBox>
      ) : null}
      <div className="form-group d-flex">
        <div className="col-sm-6">
          <form onSubmit={submitForm} >

            <div className="row pl-2 pb-1">
              <div className="col-sm-11 pb-2">
                <label htmlFor="" className="mr-sm-2">Server Model</label>

                <Select
                  isDisabled={false}
                  className={`basic-single mb-1`}
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  //  filterOption={customFilter}
                  name={"Server Model"}
                  options={serverModelList}
                  value={selectedServerModel}
                  onChange={(e) => setServerModelFunction(e)}

                />
              </div>
            </div>
            <div className="row pl-2 pb-1">
              <div className="col-sm-11 pb-2">
                <label htmlFor="" className="mr-sm-2">HIS Release Version</label>

                <Select
                  isDisabled={false}
                  className={`basic-single mb-1`}
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  //  filterOption={customFilter}
                  name={"HIS Release Version"}
                  options={hisReleaseVersionList}
                  value={selectedHisReleaseVersion}
                  onChange={(e) => setHisReleaseVersionFunction(e)}

                />
              </div>
            </div>
            <div className="row pl-2 pb-1">
              <div className="col-sm-11 pb-2">
                <label htmlFor="" className="mr-sm-2">Operating System</label>

                <Select
                  isDisabled={false}
                  className={`basic-single mb-1`}
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  //  filterOption={customFilter}
                  name={"Operating System"}
                  options={hisOsList}
                  value={selectedHisOs}
                  onChange={(e) => setHisOsFunction(e)}

                />
              </div>
            </div>
            {/* release date text field */}
            <div className="row pl-2 pb-1">
              <div className="col-sm-11 pb-2">
                <label htmlFor="" className="mr-sm-2">Release Details</label>
                <input type="text"
                  className="form-control"
                  maxLength="60"
                  name="Release Details"
                  value={release}
                  onChange={(e) => changeRelease(e)}
                  placeholder="Release Details"
                />
              </div>
            </div>

            {/* Combine key text field */}
            <div className="row pl-2 pb-1">
              <div className='col-sm-4 mb-2'>
                <button
                  type="submit"
                  className="btn btn-md btn-dark mb-3"
                  onClick={getCombineKeyValue}>
                  Generate Combine Key
                </button>
              </div>
              {combineKeyError && <div className='col-sm-8 mb-2'>
                <div class="text-danger">{errorMsg}</div>
              </div>
              }
            </div>
            <div className="row pl-2 pb-1">
              <div className="col-sm-11 pb-2">
                <input type="text"
                  className="form-control"
                  maxLength="60"
                  name="Combine Key Value"
                  value={combineKey}
                  onChange={(e) => changeCombineKey(e)}
                  placeholder="Combine Key"
                />
              </div>
            </div>
            <div className="row pl-2 pb-1">
              <div className="col-sm-11 pb-2">
                <label htmlFor={"Copy From Existing Combine Key"} className="mr-sm-2"><b>Copy From Existing Combine Keys</b></label>
                <Select
                  isDisabled={combineKey !== "" ? false : true}
                  className={`basic-single mb-1`}
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  name={"Combine Keys"}
                  value={copiedCombineKey}
                  options={combineKeyDetails.map(item=>({ id: item.id, value: item.combine_key, label: item.combine_key }))}
                  onChange={(e) => setCopiedCombineKey(e)}
                />
              </div>
            </div>
            <div className="col-sm-12">
              <button type="reset"
                onClick={resetForm}
                className="btn btn-md btn-light btn-link submit-btn-inline mr-sm-2"><i className="fa fa-refresh"></i> Reset</button>
              <button
                type="submit"
                className="btn btn-md btn-dark submit-btn-inline"
                onClick={addCombineKey}
              >
                Add Combine Key
              </button>
            </div>
          </form>
        </div>
        {/* Combine key details table */}
        <div className="col-sm-6">
          <MaterialTable
            title="Combine Keys"
            columns={[
              { title: "Combine Key", field: 'combine_key' },
              { title: "Server Model", field: 'server_model' },
              { title: "HIS Release Version", field: 'his_release_version' },
              { title: "Operating System", field: 'operating_system' },
              { title: "Release Details", field: 'release' }
            ]}
            data={combineKeyDetails}
            options={{
              headerStyle: {
                backgroundColor: '#e9ecef',
              },
              actionsColumnIndex: -1,
              selection: false,
              search: true,
              maxBodyHeight: 400
            }}
            localization={{
              header: {
                actions: 'Actions',
              },
            }}
            actions={[
              (rowData) => ({
                icon: rowData.is_deleted ? "undo" : "delete",
                tooltip: rowData.is_deleted ? "Undo Deleted Record" : "Delete Record",
                onClick: (e, data) => {
                  if (rowData.is_deleted) {
                    // call undo delete api
                    alert("TRIGGER UNDO DELETE API CALL")
                  }
                  showDeleteWarning(data)
                }
              })
            ]}
          />
        </div>
      </div>
    </div>
  )
}

export default ManageHisCombineKey
